export default "__VITE_ASSET__Cl1Mcnk0__"